<div class="select-bu btn-group" dropdown #dropdown="bs-dropdown" [autoClose]="false">
    <div class="result-select-bu">
        <input [value]="displayedValue" [placeholder]="placeholder" dropdownToggle type="text" />
        <span id="button-basic" dropdownToggle class="dropdown-toggle"
              aria-controls="dropdown-basic">
            <span class="caret"></span>
        </span>
    </div>
    <i (click)="onClearClicked()" class="fa fa-close"></i>
    <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" aria-labelledby="button-basic">
        <div class="path-bu">
            <span class="active-path-bu" (click)="resetComponent()">
                All <i class="fa fa-chevron-right"></i>
            </span>
            <span *ngFor="let item of displayedRouteList" (click)="changeCurrentEntity(item)" class="active-path-bu">
                {{ item.name }} <i class="fa fa-chevron-right"></i>&nbsp;
            </span>
        </div>
        <div class="detailing-path" [ngClass]="{'path-animation': isAnimated}">
            <div *ngFor="let item of displayedList" (click)="changeCurrentEntity(item, dropdown)">
                {{ item.name }}
                <i [ngClass]="{'fa fa-chevron-right': item.children.length}"></i>
            </div>
        </div>
        <div>
            <button class="btn-select-current" [disabled]="!currentEntity" (click)="selectEntity(dropdown)">Select current</button>
        </div>
    </div>
</div>